import { createFileRoute } from "@tanstack/react-router";
import { StakePage } from "../../features/staking/pages/stake-page";
import { assetRouteLoader } from "../../features/staking/utils/route-loaders";

export const Route = createFileRoute("/_layout/staking/$asset/stake/$vault")({
  loader: assetRouteLoader,
  component: StakePage,
});
